// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3YAk_","header":"MergedInvoice_header__3ztVj"};